module.exports = __webpack_public_path__ + "static/media/project-relations_watch.339d9131.jpg";